import React, { createRef, ReactElement, useEffect, useState } from 'react';

import { getContainerHeight } from 'helpers/commonHelper';

import { PaymentCategoryType } from 'consts';
import { PROGRESS } from 'config/config';
import { noop } from 'lodash';
import { scrollTo } from 'helpers/scrollHelper';
import { FormattedMessage } from 'react-intl';

import { ICardWLProps } from '../wl/CardWL.types';

import {
  CardWLGroupedWidgetContainer,
  CardWLGroupedContainer,
  CardWLGroupedContainerList,
  CardWLGroupedPromoElement,
  CardWLGroupedContentWrapper,
  CardWLGroupedPromoElementText,
} from './CardWLGrouped.styles';
import withCardContext from '../../../hoc/withCardContext';
import CardFormWL from '../wl/cardForm/CardFormWL';
import { CardWLGroupedItem } from './item/CardWLGroupedItem';
import { CARD_TYPE_ID, C2P_TYPE_ID } from './CardWLGrouped.types';

function CardWLGrouped(props: ICardWLProps): ReactElement {
  const {
    shouldShowCardForm,
    setIsCardComponentLoading,
    paymentMethods,
    setHeight,
    isMobileOrTablet,
    setPaymentMethodAndProgressAndNotification,
  } = props;
  const methodPromotionEnabled = false; // if you want to enable method promotion change to true
  const containerRef = createRef<HTMLDivElement>();
  const widgetRef = createRef<HTMLDivElement>();
  const [widgetHeight, setWidgetHeight] = useState<number>(0);

  const [activeCardMethodTypeId, setActiveCardMethodTypeId] = useState<string | undefined>(undefined);

  function scrollToWidget() {
    const container = document.querySelector('#root > div') as HTMLElement;
    const postion = widgetRef.current?.offsetHeight ? widgetRef.current?.offsetHeight : 0;
    const header = 50;

    scrollTo(container, postion ? postion - header : 0, 1000);
  }

  useEffect(() => {
    if (widgetHeight) {
      setHeight(widgetHeight);
    }
  }, [widgetHeight]);

  useEffect(() => {
    setHeight(getContainerHeight(containerRef.current));
    if (!shouldShowCardForm) {
      setIsCardComponentLoading(false);
    }
  }, []);

  useEffect(() => {
    setHeight(getContainerHeight(containerRef.current));
  });

  useEffect(() => {
    if (activeCardMethodTypeId) {
      const isCard = activeCardMethodTypeId === CARD_TYPE_ID;
      const selectedCardMethod = paymentMethods.filter(pm => pm.id.toString() === activeCardMethodTypeId)[0];
      setPaymentMethodAndProgressAndNotification(
        selectedCardMethod.id,
        isCard ? PaymentCategoryType.CARD : PaymentCategoryType.CLICK_TO_PAY,
        selectedCardMethod.pmpt,
        selectedCardMethod.showPaymentNotification,
        isCard ? PROGRESS.SELECT_CARD_METHOD : PROGRESS.SELECT_C2P_METHOD
      );
      if (isCard && isMobileOrTablet) scrollToWidget();
    }
  }, [activeCardMethodTypeId]);

  const isActive = (paymentMethodId: string) => {
    if (!activeCardMethodTypeId) return false;
    return paymentMethodId === activeCardMethodTypeId;
  };

  return (
    <CardWLGroupedContainer ref={containerRef} className="card-wl-grouped-payment">
      <CardWLGroupedContainerList className="card-wl-grouped-payment-list">
        <CardWLGroupedContentWrapper
          className={`card-wl-grouped-payment__${C2P_TYPE_ID}`}
          key={C2P_TYPE_ID}
          isSelected={isActive(C2P_TYPE_ID)}
          hasMethodPromotion={methodPromotionEnabled}
        >
          <CardWLGroupedItem
            methodId={C2P_TYPE_ID}
            setActiveCardMethodTypeId={setActiveCardMethodTypeId}
            isActive={isActive}
          />

          {methodPromotionEnabled && (
            <CardWLGroupedPromoElement
              className="card-wl-grouped-payment-promo-element"
              isSelected={isActive(C2P_TYPE_ID)}
            >
              <CardWLGroupedPromoElementText>
                <FormattedMessage id="paymentMethod.promo.title" />
              </CardWLGroupedPromoElementText>
            </CardWLGroupedPromoElement>
          )}
        </CardWLGroupedContentWrapper>

        <CardWLGroupedContentWrapper
          className={`card-wl-grouped-payment__${CARD_TYPE_ID}`}
          key={CARD_TYPE_ID}
          isSelected={isActive(CARD_TYPE_ID)}
        >
          <CardWLGroupedItem
            methodId={CARD_TYPE_ID}
            setActiveCardMethodTypeId={setActiveCardMethodTypeId}
            isActive={isActive}
          />
          {isActive(CARD_TYPE_ID) && (
            <CardWLGroupedWidgetContainer ref={widgetRef}>
              <CardFormWL
                {...props}
                hasSavedInstruments={false}
                handleShowSavedInstrumentClick={noop}
                setHeight={setWidgetHeight}
              />
            </CardWLGroupedWidgetContainer>
          )}
        </CardWLGroupedContentWrapper>
      </CardWLGroupedContainerList>
    </CardWLGroupedContainer>
  );
}

export default withCardContext(CardWLGrouped);
